import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiService from '../api/apiService';

// Initial state
const initialState = {
  loading: false,
  error: null,
  success: false,
  lastSubmission: null
};

// Async thunk for submitting contact form
export const submitContactForm = createAsyncThunk(
  'contact/submitContactForm',
  async (contactData, { rejectWithValue }) => {
    try {
      const response = await apiService.submitContactForm(contactData);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 
        error.message || 
        'Failed to submit contact form'
      );
    }
  }
);

// Contact slice
const contactSlice = createSlice({
  name: 'contact',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSuccess: (state) => {
      state.success = false;
    },
    resetContactState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.lastSubmission = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Submit contact form
      .addCase(submitContactForm.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(submitContactForm.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.lastSubmission = action.payload;
        state.error = null;
      })
      .addCase(submitContactForm.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  }
});

// Export actions
export const { clearError, clearSuccess, resetContactState } = contactSlice.actions;

// Export reducer
export default contactSlice.reducer;
